import {
    Column,
    Entity,
    JoinTable,
    ManyToMany,
    ManyToOne,
    PrimaryGeneratedColumn,
} from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IRefChapterRubric } from './interface/IRefChapterRubric';
import { IRefMission } from './interface/IRefMission';
import { IRefInstallationFamily } from './interface/IRefInstallationFamily';

@Entity('ref_chapter_rubric')
export class RefChapterRubric extends BaseEntity implements IRefChapterRubric {
    apiMapping = {
        id: 'id',
        name: 'name',
        order: 'ordre',
        isDeleted: 'isDeleted',
        parentId: {
            fieldName: 'parent',
            type: 'RefChapterRubric'
        },
    };

    @PrimaryGeneratedColumn()
    id: number;

    @Column()
    name: string;

    @Column()
    ordre: number;

    @Column()
    isDeleted: boolean;

    @ManyToOne('RefChapterRubric')
    parent: IRefChapterRubric;

    @ManyToMany('RefMission', 'refChapterRubrics')
    @JoinTable()
    refMissions: IRefMission[];

    @ManyToMany('RefInstallationFamily', 'refChapterRubrics')
    @JoinTable()
    refInstallationFamilies: IRefInstallationFamily[];
}
